var MemoryStorageService = function() {
  if (MemoryStorageService.prototype._singleton){
    return MemoryStorageService.prototype._singleton;
  }

  MemoryStorageService.prototype._singleton = this;

  this.data = {};

  this.get = function(key) {
    return this.data[key];
  };

  this.set = function(key, value) {
    if(key === undefined) {
      throw new Error("Cannot store an item in session with an undefined key.");
    }
    this.data[key] = value;
  };
};

module.exports = new MemoryStorageService();
